import Vue from 'vue';
import VueRouter from 'vue-router';
import VueGtm from '@gtm-support/vue2-gtm';
import Meta from 'vue-meta';
import VueMatomo from 'vue-matomo';
import routes from 'routes';
import store from 'store';
import NProgressApp from 'utils/nprogress';
import { UI_SET_LOADER } from 'store/actions/ui';
import { i18n } from '@/setup/i18n';
import { AUTH_VALIDATE } from 'store/actions/auth';

Vue.use(VueRouter);
Vue.use(Meta);

const router = new VueRouter({
  mode: 'history',
  linkActiveClass: 'active',
  hashbang: false,
  root: '/',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
  routes
});

if (process.env.NODE_ENV === 'production') {
  const appGoogleTagManagerId = process.env.GOOGLE_TAG_MANAGER_ID;
  if (appGoogleTagManagerId) {
    const appGoogleTagManagerIdParsed = appGoogleTagManagerId && appGoogleTagManagerId.split(',');
    Vue.use(VueGtm, {
      id: appGoogleTagManagerIdParsed,
      defer: false,
      enabled: true,
      loadScript: true,
      vueRouter: router,
      trackOnNextTick: false
    });
  }

  if (process.env.APP_PIXEL_MATOMO === 'enabled') {
    Vue.use(VueMatomo, {
      host: process.env.APP_PIXEL_MATOMO_SITE_URL,
      siteId: process.env.APP_PIXEL_MATOMO_SITE_ID,
      trackerFileName: 'piwik',
      enableLinkTracking: true,
      trackInitialView: true,
      router
    });
  }
}
// Redirect to the error page
const redirectToErrorPage = (next, resource) =>
  next({
    name: 'error',
    params: { resource }
  });

router.beforeEach((to, from, next) => {
  const titleKey = to.meta.titleKey;
  const titleByKey = titleKey ? `| ${i18n.t(`title.${to.meta.titleKey}`)}` : '';
  document.title = `${process.env.APP_NAME} ${titleByKey}`;

  if (['error', '404', 'legal'].indexOf(to.name) > -1) return next();

  // Valid always the Api token see action AUTH_VALIDATE in auth module
  return store
    .dispatch(`auth/${AUTH_VALIDATE}`)
    .then(() => {
      next();
    })
    .catch(() => {
      // Redirect to the error page
      redirectToErrorPage(next, AUTH_VALIDATE);
    });
});

// After navigation is confirmed, but before resolving...
router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (from.name) {
    // Start the route progress bar.
    NProgressApp.start();
  }
  next();
});

// When each route is finished evaluating...
// eslint-disable-next-line no-unused-vars
router.afterEach(to => {
  // Loader hidden
  store.dispatch(`ui/${UI_SET_LOADER}`, false);
  // Complete the animation of the route progress bar.
  NProgressApp.done();
});

export { router as default };
